import React, { useState, useEffect, useReducer } from 'react';
import './App.scss';
import { Route, Switch, BrowserRouter, useHistory } from 'react-router-dom';
import MenuMobile from './Components/MenuMobile';
import { GlobalContext } from './Contexts/GlobalContext';
import MaterialThemeProvider from './Components/MaterialThemeProvider';
import Login from './Components/Login';
import SignUp from './Components/SignUp';
import SignUp__Success from './Components/SignUp__Success';
import MailVerification from './Components/MailVerification';
import MessageBox from './Components/MessageBox';
import ForgotPassword from './Components/ForgotPassword';
import PasswordReset from './Components/PasswordReset';
import Header__Wrapper from './Components/Header__Wrapper';
import OpenOrders from './Components/Orders/OpenOrders/OpenOrders';
import OrderHistory from './Components/Orders/OrderHistory/OrderHistory';
import Categories from './Components/Categories/Categories';
import FoodAndDrinks2 from './Components/FoodAndDrinks/FoodAndDrinks2';
import Tables from './Components/Tables';
import Logo from './Components/Logo';
import Dashboard from './Components/Dashboard/Dashboard';
import Payment__Configuration from './Components/PaymentConfiguration/Payment__Configuration';
import Payment__Configuration__Completed from './Components/PaymentConfiguration/Payment__Configuration__Completed';
import Init from './Components/Init';
import CookieConsent from './Components/CookieConsent';
import Subscription from 'Components/Subscription/Subscription';
import reducer from './Components/Reducer';
import Subscription__Success from 'Components/Subscription/Subscription__Success';
import Subscription__Cancel from 'Components/Subscription/Subscription__Cancel';
import DeliverAndCollect from 'Components/Settings/DeliverAndCollect';
import MultiLanguage2 from 'Components/MultiLanguage/MultiLanguage2';
import OptionGroupsList from 'Components/OptionGroups/OptionGroupsList';
import AdvancedSettings from 'Components/Settings/AdvancedSettings';
import ColorsAndFonts from 'Components/Settings/ColorsAndFonts';
import PaynetSubscriptionForm from 'Components/Subscription/PaynetSubscriptionForm';
import PaynetConfiguration from 'Components/PaymentConfiguration/PaynetConfiguration';
import BreadCrumb from 'Components/BreadCrumb';
import PaynetSuccess from 'Components/Subscription/PaynetSuccess';
import UnpaidOrders from 'Components/Orders/UnpaidOrders';
import useGoogleAnalytics from 'CustomHooks/useGoogleAnalytics';
import GoogleAnalytics from 'Components/GoogAnalytics';
import PushSettings from 'Components/PushNotifications/PushSettings';

function App(props) {


  const [isMobile, setIsMobile] = useState();
  const [globalContext, setGlobalContext] = useState({});
  const [globalState, dispatch] = useReducer(reducer,
    {
      menuLocation: { a: 1, b: 1 },
      messageOptions: { message: '', showButton: false },
      email: '',
      alias: '',
      customerSettings: {},
      userInteractedWithTheDocument: false,
      selectedGuiLanguage: 'en',
      oneSignalInitialized: false,
      ver: '2209201124',
    }
  );

  const updateDimensions = () => {
    setIsMobile(window.innerWidth < 851 ? true : false);
  }


  useEffect(
    () => {
      updateDimensions();
      window.addEventListener("resize", updateDimensions);
      /*window.addEventListener('locationchange', function(){
        console.log('location changed!: ' + window.location.pathname);
      })*/
    }, []
  )


  return (
    <React.Fragment>
      <GlobalContext.Provider value={{ globalState: globalState, dispatchMethod: dispatch }}>
        {
          window.location.pathname != '/Login' && 
          window.location.pathname != '/SignUp'  && 
          window.location.pathname != '/ForgotPassword' &&
          window.location.pathname != '/SignUp__Success' &&
          window.location.pathname.indexOf('/mailVerification') == -1 &&
          window.location.pathname.indexOf('/passwordReset') == -1
          ?
            <Init></Init>
            : null
        }

        <MaterialThemeProvider>

          <BrowserRouter>
            <GoogleAnalytics></GoogleAnalytics>
            {
              window.location.pathname == '/SignUp' ?
                <SignUp></SignUp>
                :
                window.location.pathname == '/SignUp__Success' ?
                  <SignUp__Success></SignUp__Success>
                  :
                  window.location.pathname.indexOf('/mailVerification') == 0 ?
                    <MailVerification></MailVerification>
                    :
                    window.location.pathname == '/ForgotPassword' ?
                      <ForgotPassword></ForgotPassword>
                      :
                      window.location.pathname.indexOf('/passwordReset') == 0 ?
                        <PasswordReset></PasswordReset>
                        :
                        <React.Fragment>


                          <Header__Wrapper></Header__Wrapper>

                          <div className="body" style={{ display: 'flex' }}>
                            {(!isMobile) ?
                              <MenuMobile></MenuMobile>
                              : null
                            }



                            <div className="main-content-wrapper" >
                              <div className="main-content-inner-wrapper">

                                <BreadCrumb></BreadCrumb>
                                <Switch>
                                  <Route exact path="/Login" component={Login} />
                                  <Route exact path="/" component={Login} />
                                  <Route exact path="/OpenOrders" component={OpenOrders} />
                                  <Route exact path="/OrderHistory" component={OrderHistory} />
                                  <Route exact path="/Categories" component={Categories} />
                                  <Route exact path="/FoodAndDrinks2" component={FoodAndDrinks2} />
                                  <Route exact path="/Tables" component={Tables} />
                                  <Route exact path="/Logo" component={Logo} />
                                  <Route exact path="/Dashboard" component={Dashboard} />
                                  <Route exact path="/Payment__Configuration" component={Payment__Configuration} />
                                  <Route exact path="/Payment__Configuration__Completed" component={Payment__Configuration__Completed} />
                                  <Route exact path="/Subscription" component={Subscription} />
                                  <Route exact path="/order/success" component={Subscription__Success} />
                                  <Route exact path="/order/cancel" component={Subscription__Cancel} />
                                  <Route exact path="/Settings/DeliverAndCollect" component={DeliverAndCollect} />
                                  <Route exact path="/Settings/MultiLanguage" component={MultiLanguage2} />
                                  <Route exact path="/OptionGroupsList" component={OptionGroupsList} />
                                  <Route exact path="/AdvancedSettings" component={AdvancedSettings} />
                                  <Route exact path="/ColorsAndFonts" component={ColorsAndFonts} />
                                  <Route exact path="/PaynetSubscriptionForm" component={PaynetSubscriptionForm} />
                                  <Route exact path="/PaynetConfiguration" component={PaynetConfiguration} />
                                  <Route exact path="/subscription-result/paynet" component={PaynetSuccess} />
                                  <Route exact path="/UnpaidOrders" component={UnpaidOrders} />
                                  <Route exact path="/settings/push-notification" component={PushSettings} />
                                </Switch>

                              </div>
                            </div>

                          </div>

                        </React.Fragment>
            }
          
          </BrowserRouter>

          <MessageBox></MessageBox>
          <CookieConsent></CookieConsent>
          
        </MaterialThemeProvider>
      </GlobalContext.Provider>
    </React.Fragment>
  );
}

export default App;
